import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import InputRow from '@/components/Form/InputRow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const onCancel = () => {
            console.log('onCancel');
        };
        const onApply = () => {
            console.log('onApply');
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "card dialog" }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 우상단 닫기 버튼 "),
                    _createVNode(_component_v_btn, {
                        icon: "mdi-close",
                        variant: "text",
                        class: "btn-close",
                        onClick: onCancel
                    }),
                    _createCommentVNode(" Header "),
                    _createVNode(_component_v_card_title, { class: "dialog__head d-flex" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createElementVNode("span", { class: "header-title-text d-flex align-center" }, " 출금요청 ", -1 /* CACHED */)
                        ])),
                        _: 1 /* STABLE */,
                        __: [0]
                    }),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" Body "),
                    _createVNode(_component_v_card_text, { class: "dialog__body" }, {
                        default: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createElementVNode("p", null, "* 출금시 수수료 300원 차감됩니다.", -1 /* CACHED */)),
                            _createCommentVNode(" 허브명 "),
                            _createVNode(InputRow, {
                                label: "허브명",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 출금인증 "),
                            _createVNode(InputRow, {
                                label: "출금인증",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 출금계좌번호 "),
                            _createVNode(InputRow, {
                                label: "출금계좌번호",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 출금계좌은행 "),
                            _createVNode(InputRow, {
                                label: "출금계좌은행",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 출금 계좌 예금주 "),
                            _createVNode(InputRow, {
                                label: "출금 계좌 예금주",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 캐쉬잔액 "),
                            _createVNode(InputRow, {
                                label: "캐쉬잔액",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 예치금 "),
                            _createVNode(InputRow, {
                                label: "예치금",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 고용보험예치금 "),
                            _createVNode(InputRow, {
                                label: "고용보험예치금",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 산재보험예치금 "),
                            _createVNode(InputRow, {
                                label: "산재보험예치금",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 가맹점캐쉬 "),
                            _createVNode(InputRow, {
                                label: "가맹점캐쉬",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 기사캐쉬 "),
                            _createVNode(InputRow, {
                                label: "기사캐쉬",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 출금가능금액 "),
                            _createVNode(InputRow, {
                                label: "출금가능금액",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _cache[2] || (_cache[2] = _createElementVNode("p", null, " * 지사출금가능금액은 현재지사캐쉬 - 예치금 - 고용보험예치금 - 산재보험예치금 - 가맹점캐쉬 마이너스 합계 - 기사캐쉬합계를 반영한 금액입니다. ", -1 /* CACHED */)),
                            _createCommentVNode(" 전전분기부가세액 "),
                            _createVNode(InputRow, {
                                label: "전전분기부가세액",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 전분기부가세액 "),
                            _createVNode(InputRow, {
                                label: "전분기부가세액",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 현재분기부가세액 "),
                            _createVNode(InputRow, {
                                label: "현재분기부가세액",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _cache[3] || (_cache[3] = _createElementVNode("p", null, " * 시스템 상 매출 / 매입 부가세를 통해 추정한 부가세 신고 예상액입니다. 참고 자료로만 활용 부탁드립니다. 현재 분기 부가세액은 현재 분기 시작일~전일까지의 추정 합산 금액을 제공합니다. ", -1 /* CACHED */)),
                            _createCommentVNode(" 출금금액 "),
                            _createVNode(InputRow, {
                                label: "출금금액",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _cache[4] || (_cache[4] = _createElementVNode("p", null, [
                                _createTextVNode(" 출금한도 - 1회 0원까지"),
                                _createElementVNode("br"),
                                _createTextVNode(" 1일 0원까지"),
                                _createElementVNode("br"),
                                _createTextVNode(" 매월 0원까지"),
                                _createElementVNode("br")
                            ], -1 /* CACHED */)),
                            _createCommentVNode(" 출금메모 "),
                            _createVNode(InputRow, {
                                label: "출금메모",
                                "input-row-class": "my-2"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        "hide-details": "",
                                        variant: "outlined"
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _cache[5] || (_cache[5] = _createElementVNode("p", null, " * 은행정산 업무관계로 23시00분 ~ 01시00분까지는 캐쉬출금이 제한되오니 양해부탁드립니다. ", -1 /* CACHED */))
                        ]),
                        _: 1 /* STABLE */,
                        __: [1, 2, 3, 4, 5]
                    }),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" Footer "),
                    _createVNode(_component_v_card_actions, { class: "d-flex justify-end dialog__footer" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                                class: "brg-btn primary width-xs size-l",
                                onClick: onApply
                            }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode(" 출금요청 ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [6]
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
